import {
	Container,
	TokenTextAppearance,
	Text,
	ContainerPadding,
	TokenTextColor,
	styled,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import { formatUnixToSpanishDate, getServiceStatusColor } from '../../../helpers/servicesHelper';

const StatusIndicator = styled.div<{ status: string }>`
	background: ${(props: { status: string }) => props.status};
	border-radius: 50%;
	width: 12px;
	height: 12px;
`;

export const ServiceStatusIndicator = ({
	date,
	fullDescription,
	diffDaysCheck,
	guaranteedKmsCoverage,
}: {
	date: number | string;
	fullDescription: boolean;
	diffDaysCheck?: number;
	guaranteedKmsCoverage?: number;
}): React.ReactElement => {
	return (
		<Container
			padding={{
				top: ContainerPadding.static150,
				bottom: ContainerPadding.static300,
			}}
			wrap={'never'}
			verticalAlign={'flex-start'}
			shrinkContent
		>
			<Container
				padding={{
					right: ContainerPadding.static150,
					top: ContainerPadding.static150,
				}}
				verticalAlign="center"
			>
				<StatusIndicator status={getServiceStatusColor(date, diffDaysCheck)} />
			</Container>
			{guaranteedKmsCoverage ? (
				<Text appearance={TokenTextAppearance.copy200} color={TokenTextColor.inherit} bold>
					{fullDescription
						? `Vigente hasta el ${formatUnixToSpanishDate(date)} o hasta alcanzar los ${guaranteedKmsCoverage} km`
						: 'Vigente'}
				</Text>
			) : (
				<Text appearance={TokenTextAppearance.copy200} color={TokenTextColor.inherit} bold>
					{fullDescription ? `Vigente hasta el ${formatUnixToSpanishDate(date)}` : 'Vigente'}
				</Text>
			)}
		</Container>
	);
};
